import { LayoutType } from "@/components/signup/bxpkit-signup/src/sign-up-layout-container";

export const getQueryParams = (search: string) => {
    const params = new URLSearchParams(search);
    const edition = params.get("edition") ?? "free";
    const migrationSourceUuid = params.get("migrationSourceUuid") ?? undefined;
    const developer = params.get("developer") ?? undefined;
    let bundle = params.get("bundle");
    let layout: LayoutType = "first-impressions";
    const product = params.get("product");
    const isN2NParam = params.get("n2n") === "true";
    const shouldForceOverlayView =
        params.get("shouldForceOverlayView") === "true";

    if (bundle) {
        // do nothing but don't enter the else
    } else if (product?.includes(",")) {
        bundle = "";
    } else {
        switch (product) {
            case "jira-servicedesk.ondemand":
                bundle = "jira-service-management";
                break;
            case "confluence.ondemand":
                bundle = "confluence";
                break;
            case "jira-product-discovery":
                bundle = "jira-product-discovery";
                break;
            case "jira-servicedesk.ondemand,jira-software.ondemand":
                bundle = "jira-service-management-jira-software";
                break;
            case "jira-software.ondemand":
            default:
                bundle = "jira-software";
                break;
        }
    }

    if (migrationSourceUuid || developer) {
        layout = "default";
    }

    return {
        bundle,
        edition,
        isN2NParam,
        layout,
        product,
        migrationSourceUuid,
        developer,
        shouldForceOverlayView
    };
};
